import { adminCoolerDropDown } from '../modals/planogram';

export const all_planograms = {
  data: [
    {
      name: 'Plano007',

      cooler_value: 0,

      transaction_percentage: 0.0,

      progress_status: 'Completed',

      screen_id: 2,

      id: 14,

      planogram_status: 'Success',

      cooler_type: '12 Caser',

      channel: 'E&D',

      unit: 'Maharashtra',
      user_name: 'user',
    },

    {
      name: 'Plano0011',

      cooler_value: 0,

      transaction_percentage: 0.0,

      progress_status: 'Completed',

      screen_id: 2,

      id: 15,

      planogram_status: 'Success',

      cooler_type: '15.5 Caser',

      channel: 'MT',

      unit: 'SLMG',
      user_name: 'user',
    },

    {
      name: 'Plano0081',

      cooler_value: 0,

      transaction_percentage: 0.0,

      progress_status: 'In-progress',

      screen_id: 2,

      id: 16,

      planogram_status: 'Success',

      cooler_type: '15.5 Caser',

      channel: 'MT',

      unit: 'SLMG',
      user_name: 'user',
    },

    {
      name: 'Plano81',

      cooler_value: 0,

      transaction_percentage: 0.0,

      progress_status: 'In-progress',

      screen_id: 2,

      id: 17,

      planogram_status: 'Success',

      cooler_type: '15.5 Caser',

      channel: 'MT',

      unit: 'SLMG',
      user_name: 'user',
    },
  ],
};

export const drop_down_data = {
  data: {
    unit1: {
      channel1: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],

      channel2: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],

      channel3: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],

      channel4: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],
    },

    unit2: {
      channel1: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],

      channel2: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],

      channel3: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],

      channel4: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],
    },

    unit3: {
      channel5: ['cooler11', 'cooler21', 'cooler31', 'cooler41'],

      channel6: ['cooler10', 'cooler20', 'cooler30', 'cooler40'],

      channel7: ['cooler12', 'cooler22', 'cooler32', 'cooler42'],

      channel8: ['cooler13', 'cooler23', 'cooler33', 'cooler43'],
    },

    unit4: {
      channel11: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],

      channel21: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],

      channel31: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],

      channel41: ['cooler1', 'cooler2', 'cooler3', 'cooler4'],
    },
  },
};

export const npd_data = {
  NPDs: [
    {
      product_name: 'NPD1',

      product_id: 23,
      facings: 0,
    },

    {
      product_name: 'NPD2',

      product_id: 31,
      facings: 0,
    },

    {
      product_name: 'NPD3',

      product_id: 34,
      facings: 0,
    },
  ],

  minimum_facings: 2,

  maximum_facings: 6,
  facings: 2,
};

export const admin_cooler_dropdown_data: adminCoolerDropDown = {
  AP: {
    'E&D(Mass Eatery and QSR)': [
      '15.5 Caser',
      '45 Caser (15.5)',
      '45 Caser (30)',
      '30 Caser',
      '12 Caser',
    ],
    'E&D(Others)': [
      '45 Caser (15.5)',
      '12 Caser',
      '30 Caser',
      '45 Caser (30)',
      '15.5 Caser',
    ],
  },
};

export const skuListAndConfig = {
  facings: [
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/Monster Ultra 350 1.png',
      category: 'Energy Drink',
      brand_inswa: 'Monster',
      pack_type_revised: 'Cans',
      pack_size_revised: 350,
      diameter_mm: 58.1,
      height_mm: 158.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Monster Cans 350',
      ranking: 1,
      final_facings: 1,
      max_limit: 8,
      shelf_number: 1,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/_Variant_350ml Mango_r1 copy 1.png',
      category: 'Tea',
      brand_inswa: 'Honest Tea Mango Green Tea',
      pack_type_revised: 'PET',
      pack_size_revised: 350,
      diameter_mm: 56.0,
      height_mm: 172.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Honest Tea Mango Green Tea PET 350',
      ranking: 2,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 1,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/135ml_MAAZA_REFRESH_E com__  1.png',
      category: 'Mango',
      brand_inswa: 'Maaza Refresh',
      pack_type_revised: 'Tetra',
      pack_size_revised: 135,
      diameter_mm: 58.1,
      height_mm: 137.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Maaza Refresh Tetra 135',
      ranking: 3,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 1,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/TU ASSP 250ml E_Commerce_F 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Thums Up',
      pack_type_revised: 'PET',
      pack_size_revised: 250,
      diameter_mm: 56.0,
      height_mm: 172.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Thums Up PET 250',
      ranking: 4,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 1,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/KO ASSP_250ml copy 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Coca-Cola',
      pack_type_revised: 'PET',
      pack_size_revised: 250,
      diameter_mm: 56.0,
      height_mm: 172.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Coca-Cola PET 250',
      ranking: 5,
      final_facings: 1,
      max_limit: 8,
      shelf_number: 1,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/KO ASSP_250ml copy 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Coca-Cola',
      pack_type_revised: 'PET',
      pack_size_revised: 250,
      diameter_mm: 56.0,
      height_mm: 172.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Coca-Cola PET 250',
      ranking: 5,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 2,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/Limca assp 250ml  1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Limca',
      pack_type_revised: 'PET',
      pack_size_revised: 250,
      diameter_mm: 56.0,
      height_mm: 172.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Limca PET 250',
      ranking: 6,
      final_facings: 3,
      max_limit: 8,
      shelf_number: 2,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/KO_300ML_CAN copy 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Coca-Cola',
      pack_type_revised: 'Cans',
      pack_size_revised: 300,
      diameter_mm: 58.1,
      height_mm: 137.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Coca-Cola Cans 300',
      ranking: 8,
      final_facings: 3,
      max_limit: 8,
      shelf_number: 2,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/TUC Mold_250ml bottle_1 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Charged by Thums Up',
      pack_type_revised: 'PET',
      pack_size_revised: 250,
      diameter_mm: 56.0,
      height_mm: 172.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Charged by Thums Up PET 250',
      ranking: 9,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 3,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/DKO_300ML_CAN copy 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Diet Coke',
      pack_type_revised: 'Cans',
      pack_size_revised: 300,
      diameter_mm: 58.1,
      height_mm: 137.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Diet Coke Cans 300',
      ranking: 10,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 3,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/COKE_ZERO_IND_300ML_CAN copy 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Coke Zero',
      pack_type_revised: 'Cans',
      pack_size_revised: 300,
      diameter_mm: 58.1,
      height_mm: 137.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Coke Zero Cans 300',
      ranking: 11,
      final_facings: 3,
      max_limit: 8,
      shelf_number: 3,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/SCHWEPPES_300ml_CAN_TONIC_WATER_1 1.png',
      category: 'Mixers',
      brand_inswa: 'Schweppes Tonic Water',
      pack_type_revised: 'Cans',
      pack_size_revised: 300,
      diameter_mm: 58.1,
      height_mm: 137.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Schweppes Tonic Water Cans 300',
      ranking: 12,
      final_facings: 1,
      max_limit: 8,
      shelf_number: 3,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/SCHWEPPES_300ml_CAN_TONIC_WATER_1 1.png',
      category: 'Mixers',
      brand_inswa: 'Schweppes Tonic Water',
      pack_type_revised: 'Cans',
      pack_size_revised: 300,
      diameter_mm: 58.1,
      height_mm: 137.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Schweppes Tonic Water Cans 300',
      ranking: 12,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 4,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/MMPO_250ml 1.png',
      category: 'Non Mango',
      brand_inswa: 'MINUTE MAID PULPY',
      pack_type_revised: 'PET',
      pack_size_revised: 250,
      diameter_mm: 56.0,
      height_mm: 165.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'MINUTE MAID PULPY PET 250',
      ranking: 17,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 4,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/Maaza new  250ml_F 1.png',
      category: 'Mango',
      brand_inswa: 'Maaza',
      pack_type_revised: 'PET',
      pack_size_revised: 250,
      diameter_mm: 56.0,
      height_mm: 165.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Maaza PET 250',
      ranking: 18,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 4,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/Limca RGB 200 St_W-01 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Limca',
      pack_type_revised: 'RGB',
      pack_size_revised: 200,
      diameter_mm: 58.1,
      height_mm: 137.0,
      mrp: 1,
      shelf: 'SS',
      sku_face: 'Limca RGB 200',
      ranking: 20,
      final_facings: 2,
      max_limit: 8,
      shelf_number: 4,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/Coke 750ml_Front (1) 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Coca-Cola',
      pack_type_revised: 'PET',
      pack_size_revised: 750,
      diameter_mm: 75.0,
      height_mm: 265.0,
      mrp: 1,
      shelf: 'OTG',
      sku_face: 'Coca-Cola PET 750',
      ranking: 7,
      final_facings: 2,
      max_limit: 6,
      shelf_number: 5,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/KINLEY_SODA_750ml_-01 1.png',
      category: 'Mixers',
      brand_inswa: 'Kinley Soda',
      pack_type_revised: 'PET',
      pack_size_revised: 750,
      diameter_mm: 75.0,
      height_mm: 265.0,
      mrp: 1,
      shelf: 'OTG',
      sku_face: 'Kinley Soda PET 750',
      ranking: 13,
      final_facings: 1,
      max_limit: 6,
      shelf_number: 5,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/Maaza New 600 ml_F 1.png',
      category: 'Mango',
      brand_inswa: 'Maaza',
      pack_type_revised: 'PET',
      pack_size_revised: 600,
      diameter_mm: 72.0,
      height_mm: 220.0,
      mrp: 1,
      shelf: 'OTG',
      sku_face: 'Maaza PET 600',
      ranking: 19,
      final_facings: 1,
      max_limit: 6,
      shelf_number: 5,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/LIMCA E Commerce_750ml_F 1.png',
      category: 'Core Sparkling',
      brand_inswa: 'Limca',
      pack_type_revised: 'PET',
      pack_size_revised: 750,
      diameter_mm: 75.0,
      height_mm: 265.0,
      mrp: 1,
      shelf: 'OTG',
      sku_face: 'Limca PET 750',
      ranking: 27,
      final_facings: 2,
      max_limit: 6,
      shelf_number: 5,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/_KINLEY_1000ml_V4_PET_ICC_B 1.png',
      category: 'Water',
      brand_inswa: 'KINLEY Water',
      pack_type_revised: 'PET',
      pack_size_revised: 1000,
      diameter_mm: 84.0,
      height_mm: 277.0,
      mrp: 1,
      shelf: 'HPET',
      sku_face: 'KINLEY Water PET 1000',
      ranking: 14,
      final_facings: 2,
      max_limit: 5,
      shelf_number: 6,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/Dasani 1 Ltr Pack Shot_F 1.png',
      category: 'Water',
      brand_inswa: 'DASANI',
      pack_type_revised: 'PET',
      pack_size_revised: 1000,
      diameter_mm: 84.0,
      height_mm: 277.0,
      mrp: 1,
      shelf: 'HPET',
      sku_face: 'DASANI PET 1000',
      ranking: 15,
      final_facings: 2,
      max_limit: 5,
      shelf_number: 6,
    },
    {
      sku_image_uri:
        'https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/MM_HI_Mixed_Fruit_1Ltr_FBO-07 1.png',
      category: 'Non Mango',
      brand_inswa: 'MINUTE MAID HONEY INFUSED',
      pack_type_revised: 'Tetra',
      pack_size_revised: 1000,
      diameter_mm: 72.0,
      height_mm: 246.0,
      mrp: 1,
      shelf: 'HPET',
      sku_face: 'MINUTE MAID HONEY INFUSED Tetra 1000',
      ranking: 16,
      final_facings: 1,
      max_limit: 5,
      shelf_number: 6,
    },
  ],
  shelves: [
    {
      shelf: 'SS',
      max_limit: 8,
      shelf_number: 1,
    },
    {
      shelf: 'SS',
      max_limit: 8,
      shelf_number: 2,
    },
    {
      shelf: 'SS',
      max_limit: 8,
      shelf_number: 3,
    },
    {
      shelf: 'SS',
      max_limit: 8,
      shelf_number: 4,
    },
    {
      shelf: 'OTG',
      max_limit: 6,
      shelf_number: 5,
    },
    {
      shelf: 'HPET',
      max_limit: 5,
      shelf_number: 6,
    },
  ],
  id: 89,
};


export const leftSkuList= {
  "all": [
      {
          "shelf_type": "SS",
          "sku_name": "Core SparklingChargedCharged by Thums UpTHUMS UP CHARGED BERRY BOLTMobile SSPET250",
          "brand_inswa": "Charged by Thums Up",
          "category": "Core Sparkling",
          "pack_type_revised": "PET",
          "pack_size_revised": 250,
          "height": 172.0,
          "diameter": 56.0,
          "mrp": 1,
          "sku_image_uri": "https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/TUC Mold_250ml bottle_1 1.png"
      },
    ],
"recommended": [
      {
          "shelf_type": "SS",
          "sku_name": "Monster Cans 350",
          "brand_inswa": "Monster",
          "category": "Energy Drink",
          "pack_type_revised": "Cans",
          "pack_size_revised": 350,
          "height": 158.0,
          "diameter": 58.1,
          "mrp": 1.0,
          "sku_image_uri": "https://cciplanogramstorage.blob.core.windows.net/development/CroppedSkuImages/Monster 350 1.png"
      },
]}

export const reviewKpis={
        "revenue": 27,
        "volume": 4,
        "profit": 120000,
        "category_distribution": {
            "Core Sparkling": 25,
            "Energy Sparkling": 15,
            "Mixers": 50,
            "Stills": 10
        },
        "brand_distribution": {
            "Fanta": 25,
            "Coke": 15,
            "Kinley": 50,
            "Maaza": 10
        },
        "pack_segment_distribution": {
            "Pack Segment 1": 25,
            "Pack Segment 2": 15,
            "Pack Segment 3": 50,
            "Pack Segment 4": 10
        },
        "space_filled": {
            "% Space Filled": {
                "coverage": 96,
                "total": 100
            },
            "Shelf Filled": {
                "coverage": 5,
                "total": 5
            },
            "Facings Filled": {
                "coverage": 35,
                "total": 35
            },
            "Width Covered": {
                "coverage": 1.5,
                "total": 1.5
            },
            "Height Covered": {
                "coverage": 5.2,
                "total": 5.5
            }
        }
}

export const shelfColumns = ['shelf_1','shelf_2','shelf_3','shelf_4','shelf_5','shelf_6','shelf_7','shelf_8','shelf_9','shelf_10']